// @ts-nocheck
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { persistor, mainStore } from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { ClientId } from "./utils/configurable";
import { BrowserRouter as Router } from "react-router-dom";
import disableDevtool from "disable-devtool";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

// disableDevtool();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <DndProvider backend={HTML5Backend}>
    <Provider store={mainStore}>
      <Router>
        <App />
      </Router>
    </Provider>
  </DndProvider>
);

reportWebVitals();
